import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Button from '@mui/material/Button'
import Chip from '@mui/material/Chip'
import Tooltip from '@mui/material/Tooltip'
import OpenInNew from '@mui/icons-material/OpenInNew'
import MailIcon from '@mui/icons-material/Email'
import MailOutlineIcon from '@mui/icons-material/Drafts'
import classNames from 'classnames'
import _ from 'lodash'

import styles from './PainelAlertas.module.css'
import App from '../App'
import { recuperarAlertas, marcarAlertasComoLidas } from '../../actions/alertasActions'
import { temUnidadesAtuaisSelecionadas } from '../../controllers/unidadesController'
import { ESCOPOS_NOTIFICACAO } from '../../controllers/alertasController'
import { visualizarUrlSistemaLinksPrincipais } from '../../controllers/itensController'
import TablePagination from '@mui/material/TablePagination'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'

const INITIAL_ROWS_PER_PAGE = 10

export class PainelAlertas extends Component {
  constructor(props) {
    super(props)
    this.state = {
      page: 0,
      exibirAlertasLidas: true,
      deveMarcarAlertasComoLidas: false,
      rowsPerPage: INITIAL_ROWS_PER_PAGE
    }
  }
  debounce = _.debounce(() => this.setState({ deveMarcarAlertasComoLidas: true }), 30000)

  componentDidMount() {
    const {
      filtros: { unidadesAtuais },
      alertas: { naoLidas }
    } = this.props
    if (_.size(naoLidas)) {
      this.handleRegistrarAcessoPainelAlertas()
    }
    if (temUnidadesAtuaisSelecionadas(unidadesAtuais)) {
      this.props.recuperarAlertas()
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { deveMarcarAlertasComoLidas } = this.state
    const {
      alertas: { naoLidas }
    } = this.props
    if (deveMarcarAlertasComoLidas) {
      const alertasNaoLidas = _.map(naoLidas, (alerta) => alerta.codigo)
      this.handleMarcarAlertasComoLidas(alertasNaoLidas)
    }
  }

  componentWillUnmount() {
    this.debounce.cancel()
  }

  handleRegistrarAcessoPainelAlertas() {
    this.debounce()
  }

  handleMarcarAlertasComoLidas(alertasNaoLidas) {
    if (_.size(alertasNaoLidas)) {
      this.props.marcarAlertasComoLidas(alertasNaoLidas)
      this.setState({ deveMarcarAlertasComoLidas: false })
      this.props.recuperarAlertas()
    }
  }

  handleVerProcessoButtonClick(processo) {
    const urlParams = `?redirectTo=/processos/codigo/${processo.codigo}`
    const callback = (url) => window.open(`${url}${urlParams}`, '_blank')
    visualizarUrlSistemaLinksPrincipais('processos', callback)
  }

  handleVerDocumentoProcessoTVPClick(codigoDocumento, codigoProcesso) {
    const urlParams = `?redirectTo=/processos/codigo/${codigoProcesso}/peca/${codigoDocumento}`
    const callback = (url) => window.open(`${url}${urlParams}`, '_blank')
    visualizarUrlSistemaLinksPrincipais('processos', callback)
  }

  handleExpansionPanelChange(key, expanded, alerta) {
    if (!alerta.lida && expanded) {
      this.handleMarcarAlertasComoLidas([alerta.codigo])
    }
    this.setState({ [key]: expanded })
  }

  renderAlertasTitleGrid() {
    const {
      alertas: { qtdeAlertas, qtdeAlertasNaoLidas }
    } = this.props
    return qtdeAlertas ? (
      <Grid item xs={6}>
        {qtdeAlertasNaoLidas ? (
          <Typography color='textPrimary' className={styles.qntNaoLida}>
            <span id='totalAlertas' className={styles.tituloNaoLidas}>
              {qtdeAlertasNaoLidas}
            </span>
            {qtdeAlertasNaoLidas > 1 ? 'Notificações não lidas' : 'Notificação não lida'}
          </Typography>
        ) : (
          <Typography variant='h5' color='primary'>
            Notificações
          </Typography>
        )}
      </Grid>
    ) : (
      <Grid
        item
        md={10}
        lg={11}
        xl={8}
        className={styles.alertasTitleGrid}
        container
        justifyContent='center'>
        <Typography variant='body2' color='textSecondary'>
          Não existem notificações a exibir no momento.
        </Typography>
      </Grid>
    )
  }

  renderExibirNotificacoesLidasCheckbox() {
    const { exibirAlertasLidas } = this.state
    const {
      alertas: { qtdeAlertas, qtdeAlertasNaoLidas }
    } = this.props
    return qtdeAlertas ? (
      <Grid
        container
        item
        xs={6}
        key={_.uniqueId('item-notificacoes-exibir-')}
        justifyContent={'flex-end'}>
        {
          <FormControlLabel
            id={`exibir-lidas`}
            control={
              <Checkbox
                key={_.uniqueId('notificacao-')}
                style={{ padding: 8 }}
                color='primary'
                disabled={!qtdeAlertasNaoLidas}
                value='exibirAlertasLidas'
                checked={exibirAlertasLidas}
                onChange={(event) => this.setState({ exibirAlertasLidas: event.target.checked })}
              />
            }
            label={'Exibir notificações lidas'}
          />
        }
      </Grid>
    ) : null
  }

  renderEscopoChip({ escopo, processo }) {
    const color = ESCOPOS_NOTIFICACAO[escopo].color
    const icon = ESCOPOS_NOTIFICACAO[escopo].icone
    const fallBackEscopoLabel = _.isNil(processo.descricaoUnidadeResponsavelTecnica)
      ? ESCOPOS_NOTIFICACAO[escopo].codigo
      : processo.descricaoUnidadeResponsavelTecnica
    const escopoChip =
      escopo === ESCOPOS_NOTIFICACAO.UNIDADE.codigo ? `${fallBackEscopoLabel}` : escopo
    return <Chip icon={icon} label={escopoChip} style={{ color, border: 'none' }} />
  }

  renderNotificacoesIcon(ehNotificacaoLida) {
    return ehNotificacaoLida ? (
      <MailOutlineIcon fontSize={'small'} className={styles.notificacoesLidasIcon} />
    ) : (
      <MailIcon fontSize={'small'} className={styles.notificacoesNaoLidasIcon} />
    )
  }

  renderAlertaSummary({ titulo, escopo, processo, lida, dataHoraCriacaoFormatada }) {
    return (
      <Grid container spacing={2} alignItems='center'>
        <Grid item xs={8} md={9}>
          <Typography
            noWrap
            variant='body2'
            className={classNames(
              !lida ? styles.notificacoesLidaLabel : styles.notificacoesNaoLidaLabel
            )}>
            {this.renderNotificacoesIcon(lida)} {titulo}
          </Typography>
        </Grid>
        <Grid item xs={4} md={3} container justifyContent='space-between' alignItems={'center'}>
          <Typography component='div'>{this.renderEscopoChip({ escopo, processo })}</Typography>
          {dataHoraCriacaoFormatada ? (
            <Typography variant='body2' color='textSecondary' component='div'>
              {dataHoraCriacaoFormatada}
            </Typography>
          ) : null}
        </Grid>
      </Grid>
    )
  }

  renderMensagemNotificacao({ mensagem }) {
    return (
      <Grid item xs={12}>
        <Typography variant='body2'>{mensagem}</Typography>
      </Grid>
    )
  }

  renderDocumentosNotificacao({ documentos, processo }) {
    return _.size(documentos) ? (
      <Grid item xs={12}>
        <Typography variant='body2' gutterBottom color='textSecondary'>
          Documento(s)
        </Typography>
        <Grid container spacing={1}>
          {_.map(documentos, (doc) => (
            <Tooltip title={doc.descricao} placement='bottom' key={_.uniqueId(doc.codigoDocumento)}>
              <Grid
                item
                xs={3}
                md={4}
                lg={3}
                id='button-ver-documento-notificacao'
                onClick={() =>
                  this.handleVerDocumentoProcessoTVPClick(doc.codigoDocumento, processo.codigo)
                }>
                <Grid container justifyContent='space-between' className={styles.documentoBox}>
                  <Typography variant='body1' component='div' noWrap style={{ cursor: 'pointer' }}>
                    {doc.descricao}
                  </Typography>
                  <OpenInNew style={{ color: '#5AB1FE' }} />
                </Grid>
              </Grid>
            </Tooltip>
          ))}
        </Grid>
      </Grid>
    ) : null
  }

  renderAlertaProcessoDetails(alerta) {
    const { processo } = alerta
    const assunto = _.size(_.trim(processo.assunto)) ? processo.assunto : `Sem assunto.`
    return (
      <Grid container spacing={2}>
        <Grid
          container
          item
          xs={10}
          justifyContent={'flex-end'}
          spacing={2}
          key={_.uniqueId('processo-atualizado-')}>
          {this.renderMensagemNotificacao(alerta)}
          {this.renderDocumentosNotificacao(alerta)}
          <Grid item xs={12}>
            <Paper
              elevation={0}
              spacing={2}
              style={{ backgroundColor: '#F6F6F6', border: '1px solid #E9E9E9', padding: 16 }}>
              <Typography variant='body2' gutterBottom color='textSecondary'>
                Assunto do processo
              </Typography>
              <Typography variant='caption'>{_.toUpper(assunto)}</Typography>
            </Paper>
          </Grid>
        </Grid>
        <Grid container item xs={2} justifyContent={'flex-end'}>
          <Button
            variant='outlined'
            id='button-ver-proecesso'
            color='primary'
            className={styles.buttonVerProcesso}
            onClick={() => this.handleVerProcessoButtonClick(processo)}>
            Ver processo
          </Button>
        </Grid>
      </Grid>
    )
  }

  renderAlertaExpansionPanel(alerta) {
    const key = `expansion-painel-alerta-${alerta.codigo}`
    return (
      <Accordion
        key={key}
        expanded={this.state[[key]]}
        onChange={(event, expanded) => this.handleExpansionPanelChange(key, expanded, alerta)}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          {this.renderAlertaSummary(alerta)}
        </AccordionSummary>
        <AccordionDetails classes={{ root: styles.conteudoExpansivel }}>
          {this.renderAlertaProcessoDetails(alerta)}
        </AccordionDetails>
      </Accordion>
    )
  }

  renderNotificacoesPaginationGrid() {
    const { page, rowsPerPage } = this.state
    const {
      alertas: { qtdeAlertas }
    } = this.props
    return qtdeAlertas ? (
      <Grid item md={10} lg={11} xl={9}>
        <TablePagination
          id={`pagination-item`}
          component={Grid}
          item
          xs={12}
          count={qtdeAlertas}
          page={page}
          rowsPerPage={rowsPerPage}
          labelRowsPerPage='Itens por página'
          labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
          rowsPerPageOptions={[
            INITIAL_ROWS_PER_PAGE,
            INITIAL_ROWS_PER_PAGE * 2,
            INITIAL_ROWS_PER_PAGE * 3
          ]}
          onPageChange={(event, pageNumber) => this.setState({ page: pageNumber })}
          onRowsPerPageChange={(event) => this.setState({ rowsPerPage: event.target.value })}
        />
      </Grid>
    ) : null
  }

  render() {
    const { page, rowsPerPage, exibirAlertasLidas } = this.state
    const {
      alertas: { lidas, naoLidas }
    } = this.props
    const notificacoes = exibirAlertasLidas
      ? [].concat(naoLidas).concat(lidas)
      : [].concat(naoLidas)
    const notificacoesSliced = _.slice(
      notificacoes,
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    )
    return (
      <App>
        <Grid container spacing={6} justifyContent='center'>
          <Grid
            container
            item
            sm={11}
            md={10}
            lg={11}
            xl={9}
            alignItems='center'
            className={styles.alertasTitleGrid}>
            {this.renderAlertasTitleGrid()}
            {this.renderExibirNotificacoesLidasCheckbox()}
          </Grid>
          <Grid item sm={11} md={10} lg={11} xl={9}>
            {notificacoesSliced.map((alerta) => this.renderAlertaExpansionPanel(alerta))}
          </Grid>
          {this.renderNotificacoesPaginationGrid()}
        </Grid>
      </App>
    )
  }
}

const mapStateToProps = ({ alertas, filtros }) => ({ alertas, filtros })

const reduxEnhanced = connect(mapStateToProps, {
  recuperarAlertas,
  marcarAlertasComoLidas
})(PainelAlertas)

export default withRouter(reduxEnhanced)
